import { ajax } from '@setel/webcommon/exposes/ajax';
import { environments } from 'environments/environment';

const BASE_URL = `${environments.apiIamBaseUrl}/api/iam`;

export function getPermissions({
  namespace,
  userId,
}: {
  namespace: string;
  userId: string;
}) {
  return ajax.get<string[]>(
    `${BASE_URL}/${namespace}/users/${userId}/permissions`
  );
}
